import { render } from "./Hotspot34.vue?vue&type=template&id=6dbcff04&scoped=true"
import script from "./Hotspot34.vue?vue&type=script&lang=js"
export * from "./Hotspot34.vue?vue&type=script&lang=js"

import "./Hotspot34.vue?vue&type=style&index=0&id=6dbcff04&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbcff04"]])

export default __exports__